

























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {InputText, InputCheckbox} from 'simpli-web-sdk'
import {Validator} from '@brazilian-utils/brazilian-utils/dist/utilities/inscricao-estadual/validators/validator'

@Component({
  components: {InputText, InputCheckbox},
})
export default class CheckboxWithOptions extends Vue {
  @Prop({type: Boolean, default: true}) flagValue!: boolean
  @Prop({type: [String, Number], default: null}) optionValue!:
    | string
    | number
    | null
  @Prop({type: String, default: null}) optionLabel!: string | null
  @Prop({type: String, default: null}) optionType!: string | null
  @Prop({type: String, default: null}) flagLabel!: string | null
  @Prop({type: String, default: ''}) inputClass?: string
  @Prop({type: Object, default: null}) validator!: Validator | null

  get flag() {
    return this.flagValue
  }

  set flag(val: boolean) {
    this.$emit('input', val)
  }

  get option() {
    return this.optionValue
  }

  set option(val: string | number | null) {
    this.$emit('updateOption', val)
  }
}
